const PaymentSuccess = () => {
    return (
  
      <>
      <div>
          <div>
              <img src="https://www.beauty-addict.com/wp-content/uploads/2021/02/Payment-success.png" alt="" srcset="" style={{width:"60%",marginTop:"80px"}}/>
          </div>
      </div>
      </>
      
    )
  }
  
  export default PaymentSuccess